const apiPath = process.env.CORE_PATH;
const adminPath = process.env.ADMIN_PATH;
const pushApiPath = process.env.PUSH_PATH;
const samlPath = process.env.SAML_PATH;
const webSocketPath = process.env.WS_PATH;
const godmodeServerPath = process.env.GODMODE_SERVER_PATH;
const cookiePath = process.env.COOKIE_PATH;
const authApiPath = `${apiPath}/v1/accounts`;
const financeApiPath = `${apiPath}/v1/finances`;
const hamlAdminPath = `${adminPath}/admin`;
const connectPath = process.env.CONNECT_PATH;
const securePath = process.env.SECURE_PATH;
const gtmKey = process.env.GTM_KEY;
const gtmGodmodeKey = process.env.GTM_GODMODE_KEY;
const gtmAuthKey = process.env.GOOGLE_AUTH_KEY;
const gtmPrevEnv = process.env.GOOGLE_PREVIEW_ENV;
const googleApiKey = process.env.GOOGLE_KEY;
const showOpenBooking = process.env.SHOW_OPEN_BOOKING;
const interPricePDF = process.env.INTER_PRICE_PDF;
const buyerPricePDF = process.env.BUYER_PRICE_PDF;
const helpscoutKey = process.env.HELPSCOUT_KEY;
const supplierHelpscoutKey = process.env.SUPPLIER_HELPSCOUT_KEY;
const externalLoginPage = process.env.EXTERNAL_LOGIN_PAGE;
const feServerAPIAccessKey = process.env.FE_SERVER_API_ACCESS_KEY;
const iosAppLink = process.env.IOS_APP_LINK;
const androidAppLink = process.env.ANDROID_APP_LINK;
const vueAppTheme = process.env.VUE_APP_THEME;
const translationOnly = process.env.TRANSLATION_ONLY;
const googleRecaptchaSiteKey = process.env.GOOGLE_RECAPTCHA_SITE_KEY;

// A cookie whose Domain attribute does not cover the host that set it is
// silently dropped by the browser, and one build can be served from more than
// one hostname, so fall back to a host-only cookie whenever COOKIE_PATH names
// a different site than the one we are running on.
export const cookieDomain = (hostname) => {
  if (!cookiePath || !hostname || hostname === 'localhost') return null;
  const base = cookiePath.replace(/^\./, '');
  return (hostname === base || hostname.endsWith(`.${base}`)) ? cookiePath : null;
};

export default {
  // HEROKU AND FAKE_DEVELOPMENT VARIABLES
  API_PATH: apiPath,
  VUE_APP_THEME: vueAppTheme,
  TRANSLATION_ONLY: translationOnly === 'true',
  ADMIN_PATH: adminPath,
  AUTH_API_PATH: authApiPath,
  PUSH_API_PATH: pushApiPath,
  SAML_PATH: samlPath,
  COOKIE_PATH: cookiePath,
  CONNECT_PATH: connectPath,
  SECURE_PATH: securePath,
  WEB_SOCKET_PATH: webSocketPath,
  FINANCE_API_PATH: financeApiPath,
  HAML_ADMIN_PATH: hamlAdminPath,
  GODMODE_SERVER_PATH: godmodeServerPath,
  EXTERNAL_LOGIN_PAGE: externalLoginPage,
  SHOW_OPEN_BOOKING: showOpenBooking,
  INTER_PRICE_PDF: interPricePDF,
  BUYER_PRICE_PDF: buyerPricePDF,
  // KEYS
  GTM_KEY: gtmKey,
  GTM_GODMODE_KEY: gtmGodmodeKey,
  GTM_AUTH_KEY: gtmAuthKey,
  GTM_PREV_ENV: gtmPrevEnv,
  GOOGLE_KEY: googleApiKey,
  HELPSCOUT_KEY: helpscoutKey,
  SUPPLIER_HELPSCOUT_KEY: supplierHelpscoutKey,
  GOOGLE_RECAPTCHA_SITE_KEY: googleRecaptchaSiteKey,
  FE_SERVER_API_ACCESS_KEY: feServerAPIAccessKey,
  // LINKS
  IOS_APP_LINK: iosAppLink,
  ANDROID_APP_LINK: androidAppLink,
  // Enterprises migrated to Proweb book new interpretation assignments there
  PROWEB_URL: 'https://portal.tolkenett.no',
  // INTERNAL CONSTANTS
  MAX_FILE_SIZE: 5242880,
  TIMEPICKER_STEP: 5,
  // With blockUrgentBookings the booking form offers start times no sooner than this from now
  URGENT_BOOKING_WINDOW_MINUTES: 30,
  COOKIE_EXPIRATION_TIME: 2592000,
  DOCUMENT_CENTER_MAX_FILE_SIZE: 20971520,
  DOCUMENT_CENTER_ALLOWED_FILE_TYPES: ['application/pdf', 'image/png', 'image/jpeg', 'text/csv', 'text/plain', 'application/pdf', 'application/rtf', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
};
